export const POSITIVE_TRANSFER_FILTER_KEYS = ['airport_transfer', 'country_transfer'];

export const TRANSFER_FILTER_KEYS = [
  ...POSITIVE_TRANSFER_FILTER_KEYS,
  'exclude_airport_transfer',
  'exclude_country_transfer',
];

export function normalizeTransferCodes(value) {
  const values = Array.isArray(value) ? value : [value];

  return [
    ...new Set(
      values
        .filter((value) => value !== null && value !== undefined && value !== '')
        .map((value) => String(value).toUpperCase())
    ),
  ];
}

export function availableTransfers(destinations = []) {
  const routeAirports = new Set();
  const airports = new Set();
  const countries = new Set();

  destinations.forEach((destination) => {
    const flights = destination.flights || [];

    flights.forEach((flight) => {
      const segments = flight.segments || [];
      const connections = segments.slice(0, -1);

      segments.forEach((segment) => {
        const departure = segment.departure_airport?.code;
        const arrival = segment.arrival_airport?.code;

        if (departure) routeAirports.add(String(departure).toUpperCase());
        if (arrival) routeAirports.add(String(arrival).toUpperCase());
      });

      connections.forEach((segment) => {
        const airport = segment.arrival_airport?.code;
        const country = segment.arrival_country?.code;

        if (airport) airports.add(String(airport).toUpperCase());
        if (country) countries.add(String(country).toUpperCase());
      });
    });
  });

  return { routeAirports, airports, countries };
}

export function effectiveTransfers(requested = {}, destinations = []) {
  const available = availableTransfers(destinations);

  return Object.fromEntries(
    TRANSFER_FILTER_KEYS.map((key) => {
      const allowed = key === 'airport_transfer'
        ? available.routeAirports
        : key.includes('country')
          ? available.countries
          : available.airports;
      const values = normalizeTransferCodes(requested[key]).filter((code) => allowed.has(code));

      return [key, values];
    })
  );
}

export function matchesTransfer(destination, requested, type) {
  const codes = new Set(normalizeTransferCodes(requested));
  if (codes.size === 0) return true;

  return (destination.flights || []).some((flight) =>
    (flight.segments || []).slice(0, -1).some((segment) => {
      const value =
        type === 'country' ? segment.arrival_country?.code : segment.arrival_airport?.code;

      return codes.has(String(value || '').toUpperCase());
    })
  );
}
